'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index$1 = require('../IconSvg/index.js');
var index = require('../Button/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Fav = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Fav, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Fav);

  function Fav() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Fav);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (event) {
      event.preventDefault();

      _this.props.onSelect();
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Fav, [{
    key: "render",
    value: function render() {
      var buttonProps = _rollupPluginBabelHelpers.objectSpread2({}, this.props, {
        className: "ds-atom-fav-primary-normal ".concat(this.props.className)
      });

      return /*#__PURE__*/React__default['default'].createElement(index, buttonProps, /*#__PURE__*/React__default['default'].createElement(index$1, {
        localSource: this.props.localSource,
        icon: this.props.icon
      }));
    }
  }]);

  return Fav;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(Fav, "propTypes", {
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  icon: PropTypes__default['default'].string.isRequired,
  localSource: PropTypes__default['default'].bool,
  onSelect: PropTypes__default['default'].func
});

_rollupPluginBabelHelpers.defineProperty(Fav, "defaultProps", {
  className: '',
  disabled: false,
  localSource: false,
  onSelect: function onSelect() {}
});

module.exports = Fav;
